// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"21049d38","95":"3892cce9","204":"a192069d","207":"c3a64fce","269":"248f981e","284":"e42d80e0","310":"4ab36343","452":"c08c3533","453":"dd1a63ef","732":"b169ffeb","747":"edf95163","871":"2bb555e2","920":"47ffeca2"}[chunkId] + ".chunk.js";
};